const operationRoutes = [
  {
    path: "/host/:hostId/operations",
    name: "Operations",
    icon: "icon cafe-computer",
  },
];

export default operationRoutes;
